// eslint-disable-next-line @1js/office-online-rules/no-v8-imports-for-fluentui -- disabling for existing usage
import type { IContextualMenuItem } from "@fluentui/react";
import * as React from "react";
import { shimMenuItemProps, useShimMenuProps } from "./shimMenuProps";
import {
  Menu,
  MenuTrigger,
  MenuSplitGroup,
  useId,
} from "@fluentui/react-components";
import { AppMenuItem } from "./AppMenuItem";
import { AppMenuPopover } from "../AppMenuPopover";
import { AppMenuList } from "../AppMenuList";
import { MenuItemShim } from "./MenuItemShim";
import { useAppMenuItemCustomStyles } from "./useAppMenuItemStyles";
import { useMenuStyles } from "../AppContextualMenu/useAppMenuStyles";
import type { ShortcutMetadata } from "./ShortcutPills.types";

export type SubMenuProps = {
  itemProps: IContextualMenuItem;
  onDismiss?: (
    ev?: Event | React.MouseEvent | React.KeyboardEvent,
    dismissAll?: boolean
  ) => void;
  shortcutMetadata?: ShortcutMetadata;
};
export const SubMenu = (subMenuProps: SubMenuProps) => {
  const props = subMenuProps.itemProps;
  const shimmedMenuProps = useShimMenuProps(props.subMenuProps!);
  const shimmedItemProps = shimMenuItemProps(props);
  const itemStyles = useAppMenuItemCustomStyles();
  const portalStyles = useMenuStyles();
  const submenuListId = useId("contextual-submenu-");
  return (
    <Menu
      mountNode={{ className: portalStyles.portalBelow }}
      {...shimmedMenuProps}
    >
      {props.split ? (
        <MenuSplitGroup>
          <AppMenuItem
            {...shimmedItemProps}
            shortcutMetadata={subMenuProps.shortcutMetadata}
          />
          <MenuTrigger disableButtonEnhancement={true}>
            <AppMenuItem
              icon={null}
              className={itemStyles.splitButton}
              shortcutMetadata={subMenuProps.shortcutMetadata}
              aria-label={props.ariaLabel}
              aria-owns={submenuListId}
            />
          </MenuTrigger>
        </MenuSplitGroup>
      ) : (
        <MenuTrigger>
          <AppMenuItem
            {...shimmedItemProps}
            hasSubmenu={true}
            shortcutMetadata={subMenuProps.shortcutMetadata}
            aria-owns={submenuListId}
          />
        </MenuTrigger>
      )}
      {props.subMenuProps?.items ? (
        <AppMenuPopover>
          <AppMenuList id={submenuListId} className={itemStyles.subMenu}>
            {props.subMenuProps.items.map((item: IContextualMenuItem) => (
              // key is added through item spread
              // eslint-disable-next-line react/jsx-key
              <MenuItemShim
                itemProps={item}
                onDismiss={subMenuProps.onDismiss}
                shortcutMetadata={subMenuProps.shortcutMetadata}
              />
            ))}
          </AppMenuList>
        </AppMenuPopover>
      ) : (
        <></>
      )}
    </Menu>
  );
};
